module.exports = __webpack_public_path__ + "img/brand_icon03.07eacf4.f571e7fb.png";